document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slideshow-track]');
    var slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    var dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
    var prevBtn = root.querySelector('[data-slideshow-prev]');
    var nextBtn = root.querySelector('[data-slideshow-next]');
    if (!track || slides.length === 0) return;

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var timer = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });

    // Swipe touch
    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - startX;
      if (delta > 40) goTo(current - 1);
      else if (delta < -40) goTo(current + 1);
      start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    goTo(0);
    start();
  });
});
